import CONSTANT from "@/services/Constant.js";

export default {
	name: "TableItem",
	props: ['props','type'],
	computed: { 
	},
	methods: {
	},
	data() {
		return {
			defaultAvatarSrc: CONSTANT.DEFAULTS.defaultAvatarSrc
		}
	}
}